import React from 'react'

let zeropad = (n) => (n.toString().length <2 ? "0"+ n : n)

class DecimalClock extends React.Component {
  constructor(props){
      super(props);
      this.isClassicTime = !1;
      this.state = { hours: 0 , minutes: 0, secondes: 0};
      this.transformClock = this.transformClock.bind(this);
  }
  componentDidMount(){
      this.timer = setInterval(() => this.tick(), 500);
  }
  componentWillUnmount(){
      clearInterval(this.timer);
  }
  tick(){
      let convertRatio = 1000/864;
      let date = new Date();
      let ticks = (date.getSeconds() + (date.getMinutes()*60) + (date.getHours()*3600)) * convertRatio;
      let hours = Math.floor(ticks / 10000);
      let minutes = Math.floor((ticks - hours * 10000) / 100);
      let secondes = Math.floor(ticks - (hours * 10000)- (minutes * 100));
      if(this.isClassicTime){
          hours = date.getHours();
          minutes = date.getMinutes();
          secondes = date.getSeconds();
      }
      this.setState({hours, minutes, secondes});
  }
  transformClock(){
      this.isClassicTime = !this.isClassicTime;
  }
  render() {
      return <div className="clock" onClick={this.transformClock}>{zeropad(this.state.hours)} : {zeropad(this.state.minutes)} : {zeropad(this.state.secondes)}</div>;
  }
}

export default DecimalClock


// WEBPACK FOOTER //
// ./src/component/clock/clock.js